import { Button } from "@/app/components/shadcn/button";
import { ButtonGroup } from "@/app/components/shadcn/button-group";
import { Minus, Plus } from "lucide-react";

interface QuantitySelectorProps {
  quantity: number;
  onDecrease: () => void;
  onIncrease: () => void;
  size?: "sm" | "default";
  disabled?: boolean;
  minQuantity?: number;
  /** Üst sınır — verilmezse artırma sınırsız (mevcut çağrıların davranışı korunur). */
  maxQuantity?: number;
}

const QuantitySelector = ({
  quantity,
  onDecrease,
  onIncrease,
  size = "default",
  disabled = false,
  minQuantity = 1,
  maxQuantity,
}: QuantitySelectorProps) => {
  const isSmall = size === "sm";

  return (
    <ButtonGroup>
      <Button
        variant="outline"
        size={isSmall ? "sm" : "icon"}
        onClick={onDecrease}
        disabled={disabled || quantity <= minQuantity}
        className={isSmall ? "h-8 w-8 p-0" : ""}
      >
        <Minus className={isSmall ? "w-3 h-3" : "w-4 h-4"} />
      </Button>
      <div
        className={`flex items-center bg-muted border-y text-sm font-medium justify-center ${
          isSmall ? "h-8 px-3 min-w-8" : "size-9"
        }`}
      >
        {quantity}
      </div>
      <Button
        variant="outline"
        size={isSmall ? "sm" : "icon"}
        onClick={onIncrease}
        disabled={disabled || (maxQuantity !== undefined && quantity >= maxQuantity)}
        className={isSmall ? "h-8 w-8 p-0" : ""}
      >
        <Plus className={isSmall ? "w-3 h-3" : "w-4 h-4"} />
      </Button>
    </ButtonGroup>
  );
};

export default QuantitySelector;
